import CategoriesAndTagsAdminColumnRenderer from './categoriesAndTagsAdminColumnRenderer.component';
import {
  adminColumnSharedFields,
  catViewColumnDefinition,
  defaultTagColumnDefiniton,
  tagNameColumnDefinition,
  subTagColumnDefinition,
} from '../../shared/columnDefinitions';
import { alignLeftCellStyle } from '@common/cellStyles';
import DescriptionCellRenderer from './descriptionCellRenderer.component';

export const adminColumnDef = {
  field: 'tagName',
  valueGetter: ({ data }) => data,
  cellRenderer: CategoriesAndTagsAdminColumnRenderer,
  ...adminColumnSharedFields,
};

export const defaultColumnDefs = [
  tagNameColumnDefinition,
  {
    headerName: 'Description',
    field: 'description',
    width: 120,
    minWidth: 100,
    ...alignLeftCellStyle,
  },
  subTagColumnDefinition,
];

export const superUserColumnDefs = [
  ...defaultColumnDefs,
  {
    ...catViewColumnDefinition,
    headerName: 'View',
    cellRenderer: DescriptionCellRenderer,
  },
  {
    ...defaultTagColumnDefiniton,
    cellRenderer: DescriptionCellRenderer,
  },
];

export const importColumnDefinitions = [
  ...defaultColumnDefs,
  {
    ...catViewColumnDefinition,
    headerName: 'View',
  },
  defaultTagColumnDefiniton,
];
